import type { DictionaryDto } from '../../lib/dictionariesApi';
import type { FieldDataType } from '../../lib/layersApi';

const DATA_TYPE_LABELS: Record<FieldDataType, string> = {
  string: 'Строка',
  text: 'Текст',
  integer: 'Целое',
  decimal: 'Дробное',
  boolean: 'Логич.',
  date: 'Дата',
  datetime: 'Дата+время',
  dictionary: 'Справочник',
};

const selectClassName =
  'h-9 w-full rounded-lg border border-border-default bg-bg-surface px-2 text-xs text-text-primary outline-none';

/** A field's data-type picker — when "Справочник" is chosen, a second select
 * appears to pick WHICH dictionary this field references (gis.layer_fields.dictionary_id).
 * Used everywhere a layer/dictionary field's data_type is edited, so the
 * dictionary-reference UX stays identical across all of them. */
export function DataTypeSelect({
  dataType,
  dictionaryId,
  dictionaries,
  onChange,
  disabled,
}: {
  dataType: FieldDataType;
  dictionaryId?: string | null;
  dictionaries: DictionaryDto[];
  onChange: (dataType: FieldDataType, dictionaryId: string | null) => void;
  disabled?: boolean;
}) {
  return (
    <div className="flex flex-col gap-1">
      <select
        value={dataType}
        disabled={disabled}
        onChange={(e) => {
          const next = e.target.value as FieldDataType;
          onChange(next, next === 'dictionary' ? (dictionaryId ?? dictionaries[0]?.id ?? null) : null);
        }}
        className={`${selectClassName} disabled:opacity-40`}
      >
        {(Object.entries(DATA_TYPE_LABELS) as [FieldDataType, string][]).map(([value, label]) => (
          <option key={value} value={value}>
            {label}
          </option>
        ))}
      </select>
      {dataType === 'dictionary' && (
        <select
          value={dictionaryId ?? ''}
          disabled={disabled}
          onChange={(e) => onChange('dictionary', e.target.value || null)}
          className={`${selectClassName} disabled:opacity-40`}
        >
          <option value="">— выберите справочник —</option>
          {dictionaries.map((d) => (
            <option key={d.id} value={d.id}>
              {d.name}
            </option>
          ))}
        </select>
      )}
    </div>
  );
}
